export default __webpack_public_path__ + "static/media/berry_mountain_768.0401eaa0.webp";